export default function IconRotate(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <path d="M2.5 12a9.5 9.5 0 1 0 9.5-9.5"/><polyline points="2.5 2.5 2.5 7.5 7.5 7.5"/>
    </svg>
  )
}
